import React from 'react';

const OverviewIcon = () => {
    return (
        <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M10 3h14v2H10zM4 1a3 3 0 1 0 3 3 3 3 0 0 0-3-3zm0 4.5A1.5 1.5 0 1 1 5.5 4 1.5 1.5 0 0 1 4 5.5zM10 11h14v2H10zM4 9a3 3 0 1 0 3 3 3 3 0 0 0-3-3zm0 4.5A1.5 1.5 0 1 1 5.5 12 1.5 1.5 0 0 1 4 13.5zM10 19h14v2H10zM4 17a3 3 0 1 0 3 3 3 3 0 0 0-3-3zm0 4.5A1.5 1.5 0 1 1 5.5 20 1.5 1.5 0 0 1 4 21.5z"/></svg>
    )
};
export default OverviewIcon;